<template>
  <div class="work-library-panel">
    <div class="panel-header">业务工作模板库</div>
    
    <!-- 基础节点区域 -->
    <div class="basic-nodes-section">
      <div class="section-title">基础节点</div>
      <div class="basic-nodes">
        <div
          v-for="node in basicNodes"
          :key="node.type"
          class="basic-node-item"
          draggable="true"
          @dragstart="handleBasicNodeDragStart($event, node)"
        >
          <i :class="node.icon"></i>
          <span>{{ node.label }}</span>
        </div>
      </div>
    </div>
    
    <!-- 业务模板区域 -->
    <el-collapse v-model="activeCategories" accordion>
      <el-collapse-item 
        v-for="category in workLibrary" 
        :key="category.categoryCode"
        :name="category.categoryCode"
      >
        <template slot="title">
          <div class="category-title">
            <i class="el-icon-s-tools"></i>
            <span>{{ category.categoryName }}</span>
          </div>
        </template>
        
        <el-collapse v-model="activeSubCategories[category.categoryCode]">
          <el-collapse-item
            v-for="subCategory in category.subCategories"
            :key="subCategory.subCode"
            :name="subCategory.subCode"
          >
            <template slot="title">
              <div class="sub-category-title">
                <i class="el-icon-s-tools"></i>
                <span>{{ subCategory.subName }}</span>
              </div>
            </template>
            
            <div class="work-items">
              <div
                v-for="workItem in subCategory.workItems"
                :key="workItem.code"
                class="work-item"
                draggable="true"
                @dragstart="handleDragStart($event, workItem, subCategory, category)"
              >
                <i class="el-icon-user-solid"></i>
                <span class="work-name">{{ workItem.name }}</span>
                <el-tag size="mini" type="info">{{ workItem.role }}</el-tag>
              </div>
              
              <!-- 拖拽整个子类 -->
              <div
                class="work-item drag-all"
                draggable="true"
                @dragstart="handleDragStartGroup($event, subCategory, category)"
              >
                <i class="el-icon-files"></i>
                <span class="work-name">拖拽全部</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import workLibraryData from './workLibrary.json'

export default {
  name: 'WorkLibraryPanel',
  props: {
    lf: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      workLibrary: workLibraryData.workLibrary,
      activeCategories: [],
      activeSubCategories: {},
      basicNodes: [
        {
          type: 'snaker:start',
          label: '开始',
          icon: 'el-icon-video-play'
        },
        {
          type: 'snaker:end',
          label: '结束',
          icon: 'el-icon-switch-button'
        },
        {
          type: 'snaker:task',
          label: '用户任务',
          icon: 'el-icon-user'
        },
        {
          type: 'snaker:decision',
          label: '条件判断',
          icon: 'el-icon-share'
        }
      ]
    }
  },
  methods: {
    handleBasicNodeDragStart(event, node) {
      const dragData = {
        type: 'basic',
        nodeType: node.type,
        label: node.label
      }
      event.dataTransfer.setData('application/json', JSON.stringify(dragData))
      event.dataTransfer.effectAllowed = 'copy'
    },
    
    handleDragStart(event, workItem, subCategory, category) {
      const dragData = {
        type: 'single',
        workItem: workItem,
        subCategory: subCategory,
        category: category
      }
      event.dataTransfer.setData('application/json', JSON.stringify(dragData))
      event.dataTransfer.effectAllowed = 'copy'
    },
    
    handleDragStartGroup(event, subCategory, category) {
      const dragData = {
        type: 'group',
        subCategory: subCategory,
        category: category
      }
      event.dataTransfer.setData('application/json', JSON.stringify(dragData))
      event.dataTransfer.effectAllowed = 'copy'
    }
  }
}
</script>

<style scoped>
.work-library-panel {
  position: absolute;
  left: 0;
  top: 0;
  width: 280px;
  height: 100%;
  background: #ffffff;
  border-right: 1px solid #e4e7ed;
  overflow-y: auto;
  z-index: 10;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.panel-header {
  padding: 20px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
  background: #fafafa;
  letter-spacing: 0.5px;
}

/* 基础节点区域 */
.basic-nodes-section {
  padding: 16px 12px;
  border-bottom: 1px solid #e4e7ed;
  background: #f5f7fa;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.basic-nodes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.basic-node-item {
  flex: 0 0 calc(50% - 5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: move;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.basic-node-item:hover {
  border-color: #409eff;
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
}

.basic-node-item:active {
  transform: translateY(0);
}

.basic-node-item i {
  font-size: 28px;
  color: #409eff;
  margin-bottom: 6px;
}

.basic-node-item span {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

.category-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.category-title i {
  margin-right: 8px;
  color: #409eff;
  font-size: 16px;
}

.sub-category-title {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #606266;
  padding-left: 12px;
  font-weight: 500;
}

.sub-category-title i {
  margin-right: 8px;
  color: #67c23a;
  font-size: 14px;
}

.work-items {
  padding: 4px 0;
}

.work-item {
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 32px;
  cursor: move;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  margin: 2px 0;
}

.work-item:hover {
  background: #f5f7fa;
  border-left-color: #409eff;
}

.work-item i {
  margin-right: 10px;
  color: #909399;
  font-size: 14px;
  flex-shrink: 0;
}

.work-item .work-name {
  flex: 1;
  font-size: 13px;
  color: #606266;
  margin-right: 8px;
  line-height: 1.5;
}

.work-item.drag-all {
  background: #ecf5ff;
  border-left-color: #409eff;
  margin-top: 8px;
  font-weight: 500;
  border-radius: 4px;
  margin-left: 8px;
  margin-right: 8px;
  padding-left: 24px;
}

.work-item.drag-all:hover {
  background: #d9ecff;
}

.work-item.drag-all .work-name {
  color: #409eff;
}

.work-item.drag-all i {
  color: #409eff;
}

/* 折叠面板样式调整 */
::v-deep .el-collapse {
  border: none;
}

::v-deep .el-collapse-item__header {
  height: 48px;
  line-height: 48px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 16px;
  font-size: 14px;
  transition: background-color 0.2s;
}

::v-deep .el-collapse-item__header:hover {
  background: #fafafa;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none;
  background: #fafafa;
}

::v-deep .el-collapse-item__content {
  padding: 8px 0;
}

::v-deep .el-collapse .el-collapse-item__header {
  padding-left: 28px;
  background: #fafafa;
  height: 44px;
  line-height: 44px;
}

::v-deep .el-collapse .el-collapse-item__header:hover {
  background: #f5f7fa;
}

::v-deep .el-tag--mini {
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  font-size: 12px;
  border-radius: 10px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* 滚动条美化 */
.work-library-panel::-webkit-scrollbar {
  width: 6px;
}

.work-library-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.work-library-panel::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.work-library-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
